import { classnames } from '@aibees/shared/utils';
import { Box, Typography } from '@mui/material';
import { memo } from 'react';
import { usePlanCardContext } from '../../context';
import * as Styled from './styles';
import * as SX from './sx';
import type { PlanBillingCycleProps as Props } from './types';

export const PlanBillingCycle = memo(({ className }: Props) => {
  const { yearly, isPaid, isMostPopular } = usePlanCardContext();

  if (!isPaid) {
    return <Box className="PlanBillingCyclePlaceholder" sx={SX.placeholder} />;
  }

  const textColor = isMostPopular ? 'common.white' : 'grey.700';

  return (
    <Styled.Wrapper
      className={classnames('PlanBillingCycle', className)}
      sx={SX.root}
      gap={0.5}
    >
      <Typography
        variant="body5"
        fontWeight={500}
        color={textColor}
        textAlign="left"
      >
        {yearly
          ? 'Billed Yearly. All Credits granted upfront.'
          : 'Billed monthly. Credits roll over up to 2X'}
      </Typography>
    </Styled.Wrapper>
  );
});

PlanBillingCycle.displayName = 'PlanBillingCycle';
